module.exports = __webpack_public_path__ + "img/paint-01.520dfbe3.png";